export const environment = {
  name: 'Testing',
  production: false,
  baseUrl: 'https://app-anthem-hns-test.visionsprr.com/api',
  // This should match the URL of the parent application that sends account data
  accountInfoSenderUrl: 'https://polite-mud-05de2e210.3.azurestaticapps.net/home',
};
